module.exports = __webpack_public_path__ + "img/a9d9272.jpeg";